<template>
  <div
    class="btn-group text-center action-buttons"
    :class="wrapperClass"
    style="margin-top: 10px; margin-bottom: 10px"
    role="group"
  >
    <button
      v-if="showPreview"
      class="btn btn-primary"
      :style="buttonStyle"
      @click="$emit('preview')"
      :disabled="previewDisabled"
    >
      <i v-if="previewIcon" :class="previewIcon" class="action-icon"></i>
      <span>{{ previewLabel }}</span>
    </button>
    <button
      v-if="showExecute"
      class="btn btn-primary"
      :class="{ 'btn-disabled': executeDisabled }"
      :style="buttonStyle"
      @click="$emit('execute')"
      :disabled="executeDisabled"
    >
      <i v-if="executeIcon" :class="executeIcon" class="action-icon"></i>
      <span>{{ executeLabel }}</span>
    </button>
    <button
      v-if="showReset"
      class="btn btn-primary"
      :style="buttonStyle"
      @click="$emit('reset')"
      :disabled="resetDisabled"
    >
      <i v-if="resetIcon" :class="resetIcon" class="action-icon"></i>
      <span>{{ resetLabel }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionButtons",
  props: {
    showPreview: {
      type: Boolean,
      default: true,
    },
    showExecute: {
      type: Boolean,
      default: true,
    },
    showReset: {
      type: Boolean,
      default: true,
    },
    previewLabel: {
      type: String,
      default: "Preview",
    },
    executeLabel: {
      type: String,
      default: "Execute",
    },
    resetLabel: {
      type: String,
      default: "Reset",
    },
    previewIcon: {
      type: String,
      default: "",
    },
    executeIcon: {
      type: String,
      default: "",
    },
    resetIcon: {
      type: String,
      default: "fa fa-times",
    },
    previewDisabled: {
      type: Boolean,
      default: false,
    },
    executeDisabled: {
      type: Boolean,
      default: false,
    },
    resetDisabled: {
      type: Boolean,
      default: false,
    },
    buttonWidth: {
      type: String,
      default: "150px",
    },
    wrapperClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
  computed: {
    buttonStyle() {
      return {
        width: this.buttonWidth,
      };
    },
  },
};
</script>

<style scoped>
.action-icon {
  font-size: 16px;
  margin-right: 4px;
}

.btn-disabled,
.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  color: #fff;
  opacity: 0.85;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
